Vue.component("custom-select-links", {
  props: {
    options: {
      required: true,
    },
    value: {
      required: false,
    },
    onChange: {
      type: Function,
      required: false,
    },
  },
  data: function () {
    return {
      isOpened: false,
    };
  },
  template: `
    <div
      :class="{'custom-select-opened' : isOpened}"
      class="custom-select"
    >
      <div
        @click="() => isOpened = !isOpened"
        class="select-current"
      >
        {{ options[value].name }}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="select-current__icon">
            <path d="M12,16c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-4,4C12.5,15.9,12.3,16,12,16z"/>
          </svg>
      </div>
      <div class="select-list">
          <div
            v-for="(option, index) in options"
            :key="'index'+'option'"
            @click="() => {
              if (onChange)
                onChange(index);
              isOpened = false;
            }"
            :class="{'select-option-selected' : (index == value) }"
            class="select-option"
          >
            <a :href="option.link" v-if="option.link">
              {{ option.name }}
            </a>
            <template v-else>
              {{ option.name }}
            </template>
          </div>
      </div>
    </div>`,
});
